import { render, staticRenderFns } from "./chapterAnalysis.vue?vue&type=template&id=2aeb9913&scoped=true"
import script from "./chapterAnalysis.vue?vue&type=script&lang=js"
export * from "./chapterAnalysis.vue?vue&type=script&lang=js"
import style0 from "./chapterAnalysis.vue?vue&type=style&index=0&id=2aeb9913&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aeb9913",
  null
  
)

export default component.exports